export default "__VITE_ASSET__BvJDjfY7__"